// src/layouts/DashboardLayout.jsx
import React from "react";
import DashboardHeader from "../components/DashboardHeader";

export default function DashboardLayout({ children }) {
  return (
    <div className="min-h-screen bg-gray-50">
      <DashboardHeader />
      <div className="max-w-7xl mx-auto px-5 py-6">
        {children}
      </div>
    </div>
  );
}
